import { Dispatch, useEffect } from "react";
import { ServiceDto } from "../../../../Api/Model/ServiceDto.csharp";
import { RelatedServiceApi } from "../../Api/RelatedServiceApi";
import { FormFields, FormReducer } from "../Helpers/formTypes";

const api = new RelatedServiceApi();

export const useRelatedServiceSetups = (
  service: ServiceDto,
  dispatch: Dispatch<any>
) => {
  useEffect(() => {
    (async () => {
      if (!service?.id) return;
      const related = await api.get(service.id);

      dispatch({
        type: FormReducer.update,
        field: FormFields.relatedServiceSetups,
        payload: related,
      });

      const showRelatedServicesMap = new Map<number, boolean>(
        Array.from(related, (relatedServiceSetup) => [
          relatedServiceSetup.relatedServiceId ?? -1,
          relatedServiceSetup.showRelatedService,
        ])
      );

      dispatch({
        type: FormReducer.update,
        field: FormFields.showRelatedServicesMap,
        payload: showRelatedServicesMap,
      });
    })();
  }, [service]);
};
